import { LoadScript } from "@react-google-maps/api";
import React from "react";
import { useEffect } from "react";
import { withLocalize } from "react-localize-redux";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import useCurrentRoute from "../utils/hooks/useCurrentRoute";
import Header from "./components/Header";
import SEO from "./components/SEO";
import Sidebar from "./components/Sidebar";
import toastr from "toastr";
import { getEnv } from "../utils/env";

const Layout = ({ title, meta, children, translate, user, settings }) => {
  const route = useCurrentRoute();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (route) {
      if (route?.canView && !route?.canView.includes(user?.role?.name)) {
        toastr.error(translate("page_not_authorized_role"));
        navigate("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, user?.role?.name, location?.pathname]);

  return (
    <>
      <LoadScript googleMapsApiKey={getEnv("REACT_APP_GOOGLE_MAPS_API_KEY")}>
        <SEO
          title={title}
          meta={meta}
          translate={translate}
          activeLanguage={settings?.language}
          defaultLanguage={getEnv("REACT_APP_DEFAULT_LANGUAGE")}
        />
        <Header user={user} settings={settings} translate={translate} />
        <Sidebar translate={translate} />
        <main>
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, {
                translate,
                activeLanguage: settings?.language,
                user,
                settings,
              });
            }
            return child;
          })}
        </main>
      </LoadScript>
    </>
  );
};

const mapStateToProps = (state) => ({
  settings: state.app.settings,
  user: state.auth.user,
});

export default connect(mapStateToProps)(withLocalize(Layout));
